import axios from '../../helpers/axios-setup';

export const downloadBundle = () => axios.get('/certifications/bundle/download');
